import React, { Component } from 'react';
import { Col, Input, Modal, Row, Typography } from 'antd';
import AddImage from '../common/AddImage';
import { connect } from 'react-redux';
import actions from '../../redux/actions/setting_data/index';
import * as yup from 'yup'
import { forEach } from 'lodash'
import utils from '../../common/utils'

const { TextArea } = Input;
const { Text } = Typography;

let schema = yup.object().shape({
  params: yup.object({
    coin: yup.string().required("Nhập tên đồng").uppercase("Tên đồng phải viết hoa").trim(),
    icon_image: yup.string().required("Thêm biếu tượng").trim(),
    name: yup.string().required("Nhập tên đồng").trim(),
    minimum_withdrawal: yup.number().required("Nhập số lượng rút").moreThan(0, "Số lượng rút phải lớn hơn 0"),
    fee: yup.number().required("Nhập phí").moreThan(0, "Phí phải lớn hơn 0"),
})
})

class PopupAddCustomCoins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleConfirm: false,
      deleteInform: false,
      imageUrl: '',
      errors: {},
      params: {
        coin: '',
        icon_image: '',
        name: '',
        symbol: '',
        decimal: '',
        minimum_withdrawal: 0,
        fee: 0,
      },
    };
  }
  
  handleOk = (e) => {
    const {params} = this.state;
    schema.validate({params}, {abortEarly: false})
    .then(value => {
      this.setState({
        visibleConfirm: true,
      });
    })
    .catch(error => {
      let errors = {};
			forEach(error.inner, (err) => {
				errors[err.path] = err.message;
      });
      this.setState({
        errors,
      });
    })
   
  };
  
  handleCancel = (e) => {
    this.props.closePopup(false);
    this.setState({
      params: {}
    })
  };
  
  handleOkConfirm = (e) => {
    
    this.props.closePopup(false);
    
    this.props.addCustomCoin(this.state.params,
      () => this.setState({
        visibleConfirm: false,
      }));
    
    // // todo refactor this
    this.props.__INIT__();
  };
  
  handleCancelConfirm = (e) => {
    this.setState({
      visibleConfirm: false,
      params: {},
    });
  };
  
  handleImage = (imageUrl) => {
    const {params} = this.state
    this.setState({ params: {...params, icon_image: imageUrl} });
  };
  
  onChangePathCoin = ({ target: { value: transaction_tx_path } }) => this.setState({ transaction_tx_path });
  
  onChangeInput = ({ target }) => {
    if (target === undefined) {
      return;
    }
    
    this.setState({
      params: {
        ...this.state.params,
        [target.name]: target.value
      }
    });
  };
  
  submit = () => {
    this.props.addCustomCoin({
      ...this.state.params,
      icon_image: this.state.imageUrl,
      fee: parseFloat(this.state.params.fee),
      symbol: this.state.params.coin,
    });
  };
  
  render() {
    const {errors}  = this.state
    return (
      <div>
        <Modal
          width="700px"
          className={'popup-add-coin'}
          title={<h3 style={{ marginBottom: 0 }}>Tạo đồng mới</h3>}
          visible={this.props.isVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          cancelText={'Hủy'}
          okText={this.props.rowUpdate ? 'Xác nhận' : 'Tạo'}
        >
          <Row>
            <Col span={11}>
              <div>Đồng</div>
              <Input
                name="coin"
                onChange={this.onChangeInput}
                placeholder="Đồng"
              />
               <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.coin'] || '')}</Text>
              </div>
            </Col>
            <Col span={11} offset={2}>
              <div>Tên đầy đủ</div>
              <Input
                name="name"
                onChange={this.onChangeInput}
                placeholder="Tên đầy đủ"
              />
               <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.name'] || '')}</Text>
              </div>
            </Col>
          </Row>
          <br/>
          <Row className="mb-medium">
            <Col span={11}>
              <div>Phí</div>
              <Input
                name="fee"
                onChange={this.onChangeInput}
                placeholder="Phí"
              />
               <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.fee'] || '')}</Text>
              </div>
            </Col>
            <Col span={11} offset={2}>
              <div>Số lượng rút nhỏ nhất</div>
              <Input
                name="minimum_withdrawal"
                onChange={this.onChangeInput}
                placeholder="Số lượng rút nhỏ nhất"
              />
               <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.minimum_withdrawal'] || '')}</Text>
              </div>
            </Col>
          </Row>
          
          <Row>
            <Col span={4}>
              <div>Biểu tượng</div>
              <div>
                <AddImage
                  handleImage={this.handleImage}
                  imageUrl={this.state.imageUrl}
                />
              </div>
              <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.icon_image'] || '')}</Text>
              </div>
            </Col>
            <Col span={19} offset={1}>
              <div>Ghi chú</div>
              <TextArea rows={4}/>
            </Col>
          </Row>
        </Modal>
        {/* confirm */}
        <Modal
          visible={this.state.visibleConfirm}
          onOk={this.submit}
          onCancel={this.handleCancelConfirm}
          cancelText={'Hủy'}
          okText={'Xác nhận'}
        >
          <div>Bạn có chắc muốn lưu thông tin?</div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  __INIT__: () => {
    dispatch({ type: '@@__INIT__' });
  },
  addCustomCoin: (params) => {
    dispatch(actions.addCustomCoinAction(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(PopupAddCustomCoins);
